import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { IGetOfferDataResponseSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { openChat } from '../../actions/chat';
import { Author, IAuthorProps } from '../../components/author';
import { selectAgentLevelInfo } from '../../selectors';
import { offerChatSelector } from '../../selectors/offerChat';
import { getRosreestrInfo } from '../../selectors/offerData/getRosreestrInfo';
import { setPhoneCollapse } from '../../store/phone_collapse';
import { showCountrysideBuilderBadge } from '../../utils/suburban';

import type { DispatchReduxAction, IState } from '../../store';

type TAuthorProps = Pick<
  IAuthorProps,
  | 'abGroup'
  | 'agent'
  | 'developer'
  | 'offer'
  | 'offerChat'
  | 'user'
  | 'kp'
  | 'showCountrysideBuilderBadge'
  | 'agentLevelInfo'
  | 'rosreestrInfo'
>;
type TOfferData = Pick<IGetOfferDataResponseSchema, 'agentAvailability' | 'agentReviews'>;
type TDispatchProps = Pick<IAuthorProps, 'setPhoneCollapse' | 'openChat'>;
type TStoreProps = TAuthorProps & TOfferData;

export const AuthorContainer = () => {
  const dispatch = useDispatch<DispatchReduxAction>();
  const stateProps: TStoreProps = {
    abGroup: useSelector((state: IState) => state.abGroup),
    agent: useSelector((state: IState) => state.offerData.agent),
    agentAvailability: useSelector((state: IState) => state.offerData.agentAvailability),
    agentReviews: useSelector((state: IState) => state.offerData.agentReviews),
    developer: useSelector((state: IState) => state.offerData.newObject && state.offerData.newObject.developer),
    kp: useSelector((state: IState) => state.offerData.kp),
    offer: useSelector((state: IState) => state.offerData.offer),
    offerChat: useSelector(offerChatSelector),
    user: useSelector((state: IState) => state.offerData.user),
    showCountrysideBuilderBadge: useSelector(showCountrysideBuilderBadge),
    agentLevelInfo: useSelector(selectAgentLevelInfo),
    rosreestrInfo: useSelector(getRosreestrInfo),
  };
  const dispatchProps: TDispatchProps = {
    setPhoneCollapse: () => dispatch(setPhoneCollapse()),
    openChat: (type?: 'open_phone' | 'open_message') => dispatch(openChat(type)),
  };

  return <Author {...stateProps} {...dispatchProps} />;
};
